import { allTeams } from './2024NFLTeams.js';

export default {
  setCurrentTeamsList(context) {
    for ( var i = 1; i <= allTeams.length; i++ ) {
      context.commit("ADD_TEAM", allTeams[i-1]);
    }
  },
};
